import { RiskConfigLofCategory } from './riskConfigLofCategory.types';
import { RiskConfigGrades } from '@Types/riskConfigGrades.types';
import { RiskConfigCofCategory } from '@Types/RiskConfigCofCategory';
import { InspectionStandardType } from './InspectionStandardType';
import { RiskMatrixObj } from './risk.types';
import { RiskPostProcessing } from '@innovyze/lib-am-common';

export enum ConfigPublishState {
	published = 'published',
	unpublished = 'unpublished',
}

export interface RiskConfig {
	configId: string;
	name: string;
	cofWeighting: number;
	lofWeighting: number;
	assetType: string;
	riskMethod: 'added' | 'multiplied';
	grades: RiskConfigGrades;
	lastRun: string;
	assetFilterId?: string;
	lastRunCompleted?: string;
	lofCfgCategories: RiskConfigLofCategory[];
	cofCfgCategories: RiskConfigCofCategory[];
	status?: string;
	runBy?: string;
	assetCount?: number;
	publishState: ConfigPublishState;
	inspectionStandard: InspectionStandardType;
	riskType?: 'linear' | 'matrix';
	matrix?: RiskMatrixObj;
	maxOverallRiskScore?: number;
	postProcessing?: RiskPostProcessing[];
	templateId?: string;
	templateVersion?: number;
}

export interface DiameterValue {
	value: number;
	unit: string;
}

export interface DataCoverageValue {
	pct: number;
}

export interface RiskDetailsRow {
	_id: string;
	ASSET_ID: string;
	/** Stored id with its asset-type prefix (`wwPipe#123`); ASSET_ID is the display part. */
	RAW_ASSET_ID?: string;
	CURRENT_SERVICE: string;
	CURRENT_STRUCTURAL: string;
	CURRENT_LOF: number;
	CURRENT_COF: number;
	CURRENT_RISK: number;
	GRADE: number;
	RISK_CHANGE: string;
	WEIGHTED_SCORES?: Record<string, number>;
	CONDITION_DATA?: string;
	MATERIAL?: string | null;
	DIAMETER?: DiameterValue | null;
	INSTALLATION_YEAR?: number | null;
	/** null = not applicable or unscored. */
	CCTV_INSPECTED?: boolean | null;
	/** UTC calendar date, YYYY-MM-DD. */
	LAST_INSPECTED?: string | null;
	INSPECTION_RERUN_NEEDED?: boolean;
	DATA_COVERAGE?: DataCoverageValue | null;
	ASSET_GEOMETRY?: GeoJSON.Geometry;
}
